import { Dialog } from "primereact/dialog";
import { DialogBase, Props, State } from "./DialogBase";
import React from "react";
import { InputText } from "primereact/inputtext";
import { Editor } from "primereact/editor";
import { Panel } from "primereact/panel";
import { Dropdown } from "primereact/dropdown";

export class DialogCardDesignComponent extends DialogBase<Props, State> {
    constructor(props: Props) {
        super(props);
    }

    render() {
        return (
            this.generateHtmlString()
        )
    }

    generateHtmlString = () => {
        let html = [];

        html.push(
            <>
                <Dialog header={"Card for " + (this.props.isEng ? this.props.ele.ENUTitle : this.props.ele.FRATitle)} footer={this.renderFooter(this.props)}
                    visible={this.props.dialogVisible} style={{ width: '50vw' }} onHide={() => this.props.callback(false)}>
                    {this.addBackground()}
                    {this.addColumnNumber()}
                    {this.addImageLayout()}
                    {this.addFields()}
                    {this.addAddButton()}

                </Dialog>
            </>
        );
        return html;
    }

    addBackground = () => {
        return (<div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '5px' }}>
            <div style={{ width: '14%' }}>
                Inline Style:
            </div>

            <InputText value={this.props.ele.InlineStyle} className='ontario-input' title="card InlineStyle"
                onChange={(e) => {
                    this.props.ele.InlineStyle = e.target.value;
                    this.props.callback();
                }} />
        </div>)
    }

    addColumnNumber = () => {
        const columnOptions = [
            { label: '1 Column', value: 1 },
            { label: '2 Columns', value: 2 },
            { label: '3 Columns', value: 3 },
            { label: '4 Columns', value: 4 }
        ];

        // Set default value to 2 if not set
        if (!this.props.ele.CardColumnNumber) {
            this.props.ele.CardColumnNumber = 2;
        }

        return (<div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '10px' }}>
            <div style={{ width: '14%' }}>
                Column Number:
            </div>
            <Dropdown
                value={this.props.ele.CardColumnNumber}
                options={columnOptions}
                onChange={(e) => {
                    this.props.ele.CardColumnNumber = e.value;
                    this.props.callback();
                }}
                placeholder="Select column number"
                style={{ width: '100%' }}
            />
        </div>)
    }

    addImageLayout = () => {
        const layoutOptions = [
            { label: 'Inline (image beside title)', value: 'inline' },
            { label: 'Top (image above title)', value: 'top' }
        ];

        // Set default value to 'inline' if not set
        if (!this.props.ele.cardImageLayout) {
            this.props.ele.cardImageLayout = 'inline';
        }

        return (<div style={{ width: '100%', display: "flex", alignItems: 'center', marginTop: '10px' }}>
            <div style={{ width: '14%' }}>
                Image Layout:
            </div>
            <Dropdown
                value={this.props.ele.cardImageLayout}
                options={layoutOptions}
                onChange={(e) => {
                    this.props.ele.cardImageLayout = e.value;
                    this.props.callback();
                }}
                placeholder="Select image layout"
                style={{ width: '100%' }}
            />
        </div>)
    }

    addAddButton = () => {
        return (<div style={{ width: "100%", paddingTop: "5px" }} >
            <button className="ontario-button ontario-button--primary" onClick={() => {

                this.addCard.call(this);
            }
            }>
                Add Card
            </button>
        </div>);
    }
    addCard = () => {
        if (!this.props.ele) return null;
        this.props.ele.Cards.push({
            CardTitle: "",
            CardTitleFRA: "",
            CardHyperlink: "",
            CardHyperlinkFRA: "",
            imageContent: "",
            bodyContent: "",
            CardbodyContent: "",
            CardbodyContentFRA: "",
            RedirectUrl: "",
            RedirectUrlFRA: "",
            Sequence: this.props.ele.Cards.length + 1,
            Script: ""
        });
        this.props.callback();
    }

    renderCardFields = (card) => {
        return (
            <div style={{ width: "100%", paddingTop: "5px" }}>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Title</div>
                    <div style={{ width: '60%' }}>
                        <InputText key={"CardTitle" + card.Sequence} className="ontario-input"
                            value={this.props.isEng ? card.CardTitle : card.CardTitleFRA}
                            onChange={(e) => {
                                if (this.props.isEng) {
                                    card.CardTitle = e.target.value;
                                } else {
                                    card.CardTitleFRA = e.target.value;
                                }
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Hyper link</div>
                    <div style={{ width: '60%' }}>
                        <Editor key={"CardHyperlink" + card.Sequence} className="ontario-input"
                            value={this.props.isEng ? card.CardHyperlink : card.CardHyperlinkFRA}
                            onTextChange={(e) => {
                                if (this.props.isEng)
                                    card.CardHyperlink = e.htmlValue;
                                else
                                    card.CardHyperlinkFRA = e.htmlValue;
                                this.props.callback();
                            }}>
                        </Editor>
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Image</div>
                    <div style={{ width: '60%' }}>
                        <Editor key={"image" + card.Sequence} className="ontario-input"
                            value={card.imageContent}
                            onTextChange={(e) => {
                                card.imageContent = e.htmlValue;
                                this.props.callback();
                            }}>
                        </Editor>
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Body content</div>
                    <div style={{ width: '60%' }}>
                        <Editor key={"image" + card.Sequence} className="ontario-input"
                            value={this.props.isEng ? card.CardbodyContent : card.CardbodyContentFRA}
                            onTextChange={(e) => {
                                if (this.props.isEng)
                                    card.CardbodyContent = e.htmlValue;
                                else
                                    card.CardbodyContentFRA = e.htmlValue;
                                this.props.callback();
                            }}>
                        </Editor>
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Redirect URL</div>
                    <div style={{ width: '60%' }}>
                        <InputText
                            key={"RedirectUrl" + card.Sequence}
                            className="ontario-input"
                            value={this.props.isEng ? (card.RedirectUrl || '') : (card.RedirectUrlFRA || '')}
                            onChange={(e) => {
                                if (this.props.isEng) {
                                    card.RedirectUrl = e.target.value;
                                } else {
                                    card.RedirectUrlFRA = e.target.value;
                                }
                                this.props.callback();
                            }}
                            placeholder="https://example.com/page"
                        />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Card Script</div>
                    <div style={{ width: '60%' }}>
                        <textarea
                            key={"CardScript" + card.Sequence}
                            className="ontario-input"
                            value={card.Script || ''}
                            onChange={(e) => {
                                card.Script = e.target.value;
                                this.props.callback();
                            }}
                            rows={8}
                            style={{ width: '100%', fontFamily: 'monospace', fontSize: '12px' }}
                            placeholder="(func) => {&#10;  // Your custom script here&#10;  // Access navigation: func.callbackStepIndex(sectionIndex)&#10;  // Access container: func.programContainer&#10;}"
                        />
                    </div>
                </div>
            </div>
        )
    }

    addFields = () => {
        if (!this.props.ele) return null;
        if (!this.props.ele.Cards) {
            this.props.ele.Cards = [];
        }
        if (this.props.ele.Cards.length == 0) {
            this.addCard();
        }

        let htmlString = []
        for (let i = 0; i < this.props.ele.Cards.length; i++) {
            const card = this.props.ele.Cards[i];
            htmlString.push(
                <Panel header={this.props.isEng ? card.CardTitle : card.CardTitleFRA} key={"CardPanel" + i}>
                    {this.renderCardFields(card)}
                </Panel>

            );
        }

        return htmlString;
    }
}